import { createQueryString, renderRoute } from "@tm/utils"
import { SummaryProps } from "../../component"

export function vehicleRedirect(props: SummaryProps) {
    const { vehicleSelectionRoute, match, history } = props
    const vehicleSelectUrl = renderRoute(vehicleSelectionRoute, { ...match.params }) + createQueryString({ redirect: "/:workTaskId/tyres/summary" })
    history.push(vehicleSelectUrl)
}
